module.exports = __webpack_public_path__ + "img/jin_09.b3617d34.png";